import { Box, Tooltip } from '@mui/material';
import { styles } from '../../styles';

interface ITooltipCheckboxProps {
  tooltipText: string;
  text: string;
}

export const TooltipCheckbox = ({ tooltipText, text }: ITooltipCheckboxProps) => (
  <Tooltip title={tooltipText}>
    <Box component="span" sx={styles.tableTooltipText}>
      {text}
    </Box>
  </Tooltip>
);
